import React from 'react'
import "./experience.css"
import html from '../../assets/skills/frontend/html-5.png'
import css from '../../assets/skills/frontend/css3.png'
import js from '../../assets/skills/frontend/javascript.png'
import react from '../../assets/skills/frontend/react.png'
import python from '../../assets/skills/backend/python.png'
import django from '../../assets/skills/backend/django.png'
import postgr from '../../assets/skills/backend/postgresql.png'
import laravel from '../../assets/skills/backend/laravel.png'
import mysql from '../../assets/skills/backend/mysql.png'
import php from '../../assets/skills/backend/php.png'
import spring from '../../assets/skills/backend/spring.jpeg'
import dart from '../../assets/skills/mobile/dart.png'
import flutter from '../../assets/skills/mobile/flutter.png'
import firebase from '../../assets/skills/mobile/firebase.png'
import kotlin from '../../assets/skills/mobile/kotlin.jpeg'

const Experience = () => {
  return (
    <section id="experience">
      <h5>What Skills I Have</h5>
      <h2>My Skills</h2>
      <div className="container experience_container">
        <div className="experience_backend">
          
          <h3>Web Development</h3>
          <div className="experience_content">
          <article className="experience_details">
              <img src={html} className="experience_details-icon" alt="html"/>
              <div>
               
                <h4>HTML</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={css} className="experience_details-icon" alt="css"/>
              <div>
               
                <h4>CSS</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={js} className="experience_details-icon" alt="javascript"/>
              <div>
               
                <h4>Javascript</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={react} className="experience_details-icon" alt="react"/>
              <div>
               
                <h4>React</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={postgr} className="experience_details-icon" alt="postgresql"/>
              <div>
               
                <h4>PostgreSQL</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={mysql} className="experience_details-icon" alt="ruby"/>
              <div>
                <h4>MySQL</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={django} className="experience_details-icon" alt="django"/>
              <div>
                <h4>Django</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={python} className="experience_details-icon" alt="python"/>
              <div>
                <h4>Python</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={laravel} className="experience_details-icon" alt="laravel"/>
              <div>
                <h4>Laravel</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={php} className="experience_details-icon" alt="php"/>
              <div>
                <h4>PHP</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            {/* <article className="experience_details">
              <img src={spring} className="experience_details-icon" alt="php"/>
              <div>
                <h4>Spring Boot</h4>
                <small className="text-light">Beginner</small>
              </div>
            </article> */}
          </div>
        </div>
        <div className="experience_mobile">
          
          <h3>Mobile Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <img src={dart} className="experience_details-icon" alt="dart"/>
              <div>
               
                <h4>Dart</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={flutter} className="experience_details-icon" alt="flutter"/>
              <div>
                <h4>Flutter</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
            <article className="experience_details">
              <img src={firebase} className="experience_details-icon" alt="firebase"/>
              <div>
                <h4>Firebase</h4>
                {/* <small className="text-light">Experienced</small> */}
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience
